import React from 'react';
import '../css/SupportPage.css'; // Optional: Create a CSS file for styling this page

const SupportPage = () => {
  return (
    <div className="support-container">
      <header className="support-header">
        <h1>Support - URL Shortener App</h1>
      </header>
      <div className="support-content">
        <h2>How Can We Help You?</h2>
        <p>If you have any questions or issues, check the resources below or contact our support team.</p>

        <h2>Support Options</h2>
        <ul>
          <li>
            <strong>FAQs:</strong> Find answers to the most frequently asked questions about our app.
          </li>
          <li>
            <strong>Documentation:</strong> Learn how to use the app with our detailed guides and tutorials.
          </li>
          <li>
            <strong>Contact Support:</strong> Reach out to our support team at{' '}
            <a href="mailto:support@urlshortenerapp.com">support@urlshortenerapp.com</a>.
          </li>
          <li>
            <strong>Community Forums:</strong> Join discussions and get help from other users in our forums.
          </li>
        </ul>

        <h2>Contact Us</h2>
        <p>
          Need further assistance? Fill out our <a href="/contact">contact form</a> or email us directly.
        </p>
      </div>
    </div>
  );
};

export default SupportPage;
